import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const AppVersion = () => {
  const $ = _c(4);
  const appVersion = process.env.REACT_APP_VERSION;
  const {
    t
  } = useTranslation();
  if (!appVersion) {
    return null;
  }
  let t0;
  if ($[0] !== t) {
    t0 = t("error.version", {
      version: appVersion
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="text-center text-xs font-normal leading-5 text-gray-400">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};